// COMPONENT
import HeaderComponent from "../../components/Header"
import MenuComponent from "../../components/SideMenu"
import BreadcrumbComponent from "../../components/Breadcrumb"
import LOGO from "../../components/image/logo-haladiem.png";
import HALADIEM from "../../components/image/haladiem.png";

// LIBRARY
import Swal from "sweetalert2"
import { toast } from "react-toastify"
import Cookies from "universal-cookie"
import ReactLoading from "react-loading"
import React, { Component } from "react"
import Pagination from "react-js-pagination"
import QRCode from "react-qr-code";
import html2canvas from 'html2canvas';

// CSS
import "../../components/css/style.css"
import "../../components/css/bootstrap.css"
import "react-slideshow-image/dist/styles.css"
import "bootstrap-daterangepicker/daterangepicker.css"

const cookies = new Cookies()
toast.configure()

export default class CardTypeScreen extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal_add: false,
      modal_edit: false,

      filter_project: "",
filter_agency: "",

      token: cookies.get("token") ? "token " + cookies.get("token") : "",
      data: null,
      card_list: null,
      uid: "",
      name: "",
      latitude: "",
      longitude: "",
      remark: "",
      project_id: "",
      agency_id: "",

      index: -1,
      subindex: -1,
      page: 1,

      project_all_list: cookies.get("user_profile")?.agency_list || null,
      agency_all_list: [],
      project_name_map: {},
    }
  }

  componentDidMount() {
    const { project_all_list } = this.state;
    this.GET()
    var user = cookies.get("user_profile")
    if (user.role_data.role_name === "system_admin") {
      this.get_Project()
    } else {
      this.get_ProjectNameMap()
      const profile = cookies.get("user_profile");

this.setState(prevState => {
  const exists = prevState.project_all_list.some(
    item => item.agency_id === profile?.agency_id
  );

  if (exists) {
    return null; // ❌ ไม่เพิ่ม ถ้ามีแล้ว
  }

  return {
    project_all_list: [
      ...prevState.project_all_list,
      {
        agency_id: profile?.agency_id,
        agency_name: profile?.agency_name,
        project_id: profile?.project_id,
        project_name: profile?.project_name,
      }
    ]
  };
});
    }
  }

  alert(icon, title, detail) {
    Swal.fire({
      icon: icon,
      title: title,
      text: detail,
      confirmButtonText: "ตกลง",
    })
  }
  GET() {
    const { page, filter_project, filter_agency } = this.state;
    this.setState({ loading: true })
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
    }
    fetch(global.api + "v1/call-service/location?page="+ page+"&project_id="+filter_project+"&agency_id="+filter_agency, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ data: result.data, loading: false })
        } else {
          switch (result.data.status) {
            case "This Page is not available":
              this.setState({ data: [] })
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }
  get_Project() {
    this.setState({ loading: true })
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
    }
    fetch(global.api + "v1/project/all", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ project_all_list: result.data.data })
          this.set_ProjectNameMap(result.data.data)
          this.setState({ loading: false })
        } else {
          switch (result.data.message) {
            case "":
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }
  // ชื่อโครงการที่ติดมากับ location บางรายการเป็นค่าเก่า (ได้ project_id มาแทนชื่อ)
  // จึงอ้างชื่อจากรายการโครงการหลัก (v1/project/all) โดยเทียบด้วย project_id
  set_ProjectNameMap(project_list) {
    const map = {}
    if (project_list) {
      project_list.forEach((item) => {
        if (item?.project_id && item?.project_name) {
          map[item.project_id] = item.project_name
        }
      })
    }
    this.setState({ project_name_map: map })
  }
  get_ProjectNameMap() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
    }
    fetch(global.api + "v1/project/all", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.set_ProjectNameMap(result.data.data)
        }
      })
      .catch((e) => {})
  }
  project_name_of(item) {
    return (
      this.state.project_name_map?.[item?.project_id] || item?.project_name || ""
    )
  }
  get_Agency(id) {
    this.setState({ loading: true })
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        project_id: id,
      }),
    }
    fetch(global.api + "v1/project/agency", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({ agency_all_list: result.data.data })
          this.setState({ loading: false })
        } else {
          switch (result.data.message) {
            case "":
              break
            default:
              this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
              cookies.remove("token")
              window.location.href = "/"
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }

  handlePageChange(pageNumber) {
    this.setState({ page: pageNumber, index: -1, card_list: null })
    setTimeout(() => {
      this.GET()
    }, 1)
  }
  Create = () => {
    this.setState({ loading: true })
    const {agency_id, name, latitude, longitude, remark} = this.state;
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
      body: JSON.stringify({
        agency_id: agency_id,
        name: name,
        latitude: latitude,
        longitude: longitude,
        remark: remark,
      }),
    }
    fetch(global.api + "v1/call-service/location/create", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.clear_form()
          this.alert("success", "สำเร็จ", "เพิ่ม QR Code แล้ว")
          this.GET()
        } else {
          switch (result.data.message) {
            case "agency id is none":
              this.alert("info", "แจ้งเตือน", "กรุณาเลือกโครงการและหน่วยงาน")
              break
            case "type card name is none":
              this.alert("info", "แจ้งเตือน", "กรุณากรอกชื่อ QR Code")
              break
            case "type card name is duplicate":
              this.alert("info", "แจ้งเตือน", "มีชื่อ QR Code นี้ในระบบแล้ว")
              break
            default:
              this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }
  Edit = () => {
    this.setState({ loading: true })
    const {uid, name, latitude, longitude, remark} = this.state;
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: this.state.token,
      },
      body: JSON.stringify({
        uid: uid,
        name: name,
        latitude: latitude,
        longitude: longitude,
        remark: remark,
      }),
    }
    fetch(global.api + "v1/call-service/location/update", requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        if (result.status) {
          this.alert("success", "สำเร็จ", "แก้ไข QR Code แล้ว")
          await this.clear_form()
          this.GET()
        } else {
          switch (result.data.message) {
            case "agency id is none":
              this.alert("info", "แจ้งเตือน", "กรุณาเลือกโครงการและหน่วยงาน")
              break
            case "type card name is none":
              this.alert("info", "แจ้งเตือน", "กรุณากรอกชื่อ QR Code")
              break
            case "type card name is duplicate":
              this.alert("info", "แจ้งเตือน", "มีชื่อ QR Code นี้ในระบบแล้ว")
              break
            default:
              this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
              break
          }
          this.setState({ loading: false })
        }
      })
      .catch((e) => {
        this.setState({ loading: false })
      })
  }
  Delete = (card) => {
    Swal.fire({
      icon: "info",
      title: "ลบ QR Code ",
      text: "ท่านแน่ใจว่าต้องการลบ QR Code  “" + card.name + "”",
      showCancelButton: true,
      confirmButtonText: "ลบข้อมูล",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loading: true })
        const requestOptions = {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: this.state.token,
          },
          accept: "application/json",
        }
        fetch(
          global.api + "v1/call-service/location/delete/" + card.uid,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status) {
              this.setState({ loading: false, page: 1 })
              this.alert("success", "แจ้งเตือน", "ลบ QR Code สำเร็จ")
              this.clear_form()
              this.GET()
            } else {
              switch (result.data.message) {
                case "":
                  break
                default:
                  this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
                  cookies.remove("token")
                  window.location.href = "/"
                  break
              }
              this.setState({ loading: false })
            }
          })
          .catch((e) => {
            this.setState({ loading: false })
          })
      }
    })
  }
  clear_form() {
    this.setState({
      modal_add: false,
      modal_edit: false,
      modal_qrcode: false,
      card_list: null,
      uid: "",
      name: "",
      latitude: "",
      longitude: "",
      remark: "",
      project_id: "",
      agency_id: "",

      index: -1,
      subindex: -1,
      page: 1,
    })
  }
  PrintQRCode = async () => {
    if(!this.qrcode) return;
    // รอให้ image + font render เสร็จ
    await new Promise(r => setTimeout(r, 300));
    const canvas = await html2canvas(this.qrcode, {useCORS: true, scale: 2, backgroundColor: null, logging: false});
    const image = canvas.toDataURL('image/png'); 
    const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>Print QR Code</title>
        <style>
          body {
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
        </style>
      </head>
      <body>
        <img src="${image}" />
        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = () => window.close();
          };
        </script>
      </body>
    </html>
  `);
  printWindow.document.close();
  }
  DownloadQRCode = async () => {
    if(!this.qrcode) return;
    // รอให้ image + font render เสร็จ
    await new Promise(r => setTimeout(r, 300));
    const canvas = await html2canvas(this.qrcode, {useCORS: true, scale: 2, backgroundColor: null, logging: false});
    const image = canvas.toDataURL('image/png'); 

    // 🔽 สร้าง link สำหรับ download
    const link = document.createElement('a');
    link.href = image;
    link.download = 'qrcode.png';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  render() {
    return (
      <div className="full bg-contain">
        {this.state.loading && (
          <div className="loading">
            <ReactLoading
              type={"spinningBubbles"}
              color="#fff"
              height={48}
              width={48}
            />
          </div>
        )}
        <div className="menu-container">
          <MenuComponent />
          <div className="w-100">
            <BreadcrumbComponent
              page1="บริการ"
              page2="จัดการคิวอาร์โค้ด"
            />
            <HeaderComponent header="จัดการคิวอาร์โค้ด" report="false" />{" "}
            {/* เมนู ฟิลเตอร์  */}
                        <div className="bg-gray px-3 pt-3 w-100">
                          <div className="row d-flex mx-0 justify-content-between">
                              {/* ตัวกรองโครงการ */}
                              <div className="mx-2 mb-3">
                                <button
                                  className="btn btn-outline-primary bg-white "
                                  onClick={() => {
                                    this.setState({ modal_filter: true })
                                  }}
                                >
                                  <span className="icon mr-2">{"\uf1de"}</span>
                                  ตัวกรองโครงการ
                                </button>
                                <div
                                  class={this.state.modal_filter ? "bg-modal" : ""}
                                  onClick={() => {
                                    this.setState({ modal_filter: false })
                                  }}
                                ></div>
            
                                {/* modal */}
                                <div
                                  class={
                                    this.state.modal_filter
                                      ? "card border-0 modal-filter p-3 mt-3"
                                      : "d-none"
                                  }
                                >
                                  {/* โครงการ */}
                                  <div class="row my-2">
                                    <div class="col-4">โครงการ:</div>
                                    <div class="col-8">
                                      <select
                                        className="form-control"
                                        value={this.state.filter_project}
                                        onChange={(e) => {
                                          this.setState({
                                            filter_project: e.target.value,
                                            filter_agency: "",
                                          })
                                          setTimeout(() => {
                                            this.get_Agency(e.target.value)
                                          }, 10)
                                        }}
                                      >
                                        <option value="" selected disabled>
                                          -- เลือกโครงการ --
                                        </option>
                                        {this.state.project_all_list &&
                                          this.state.project_all_list.map((item, index) => (
                                            <option value={item.project_id} key={index}>
                                              {item.project_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
            
                                  {/* หน่วยงาน */}
                                  <div class="row my-2">
                                    <div class="col-4">หน่วยงาน:</div>
                                    <div class="col-8">
                                      <select
                                        className="form-control"
                                        value={this.state.filter_agency}
                                        onChange={(e) => {
                                          this.setState({ filter_agency: e.target.value })
                                        }}
                                      >
                                        <option value="" selected disabled>
                                          -- เลือกหน่วยงาน --
                                        </option>
                                        {this.state.agency_all_list &&
                                          this.state.agency_all_list.map((item, index) => (
                                            <option value={item.agency_id} key={index}>
                                              {item.agency_name}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>
                                  <hr class="my-1" />
                                  {/* ปุ่ม */}
                                  <div class="row my-2">
                                    <div class="col-4"></div>
                                    <div class="col-8 d-flex">
                                      <button
                                        className="btn btn-secondary mr-2 w-50"
                                        onClick={() => {
                                          this.setState({
                                            filter_agency: "",
                                            filter_project: "",
                                            page: 1,
                                          })
            
                                          setTimeout(() => {
                                            this.GET()
                                          }, 10)
            
                                          this.setState({
                                            modal_filter: false,
                                          })
                                        }}
                                      >
                                        รีเซ็ท
                                      </button>
                                      <button
                                        className="btn btn-primary ml-2 w-50"
                                        onClick={() => {
                                          this.setState({
                                            page: 1,
                                          })
            
                                          setTimeout(() => {
                                            this.GET()
                                          }, 10)
            
                                          this.setState({
                                            modal_filter: false,
                                          })
                                        }}
                                      >
                                        <span className="icon mr-2">{"\uf1de"}</span>
                                        ยืนยัน
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                               <div className="mx-2 mb-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({ modal_add: true })
                      }}
                    >
                      + เพิ่ม QRCode
                    </button>
                  </div>
                          </div>
                        </div>
            {/* ตาราง */}
            <div className="w-100 p-3">
              <div className="table-responsive">
                <table className="table design-table">
                  <thead>
                    <tr>
                      <th className="text-left w-150px">ชื่อโครงการ</th>
                      <th className="text-left w-150px">หน่วยงาน</th>
                      <th className="text-left w-150px">ชื่อจุดสแกนคิวอาร์โค้ด</th>
                      <th className="text-left w-150px">ละติจูด</th>
                      <th className="text-left w-150px">ลองติจูด</th>
                      <th className="text-left">QRCode</th>
                      <th className="text-center  w-150px">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data?.data &&
                      this.state.data?.data?.map((item, index) => (
                        <tr key={index}>
                          <td>{this.project_name_of(item)}</td>
                          <td>{item.agency_name}</td>
                          <td>{item.name}</td>
                          <td>{item.latitude}</td>
                          <td>{item.longitude}</td>
                          <td>
                            <button
                                className="btn btn-link"
                                onClick={() => {
                                  this.setState({
                                    ...item,
                                    project_name: this.project_name_of(item),
                                    modal_qrcode: true
                                  })
                                }}
                              >
                                <span className="icon mr-2">{"\uf029"}</span>
                              </button>
                              </td>
                          <td className="text-center w-150px">
                            <div className="d-flex justify-content-center">
                              <button
                                className="btn btn-link"
                                onClick={() => {
                                  this.setState({
                                    ...item,
                                    project_name: this.project_name_of(item),
                                    modal_edit: true
                                  },() => {this.get_Agency(item.project_id)})
                                }}
                              >
                                <span className="icon mr-2">{"\uf304"}</span>
                              </button>
                              <button
                                className="btn btn-link text-danger"
                                onClick={() => {
                                  this.Delete(item)
                                }}
                              >
                                <span className="icon mr-2">{"\uf1f8"}</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            {/* pagination */}
            {this.state.data && (
              <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                <div>
                  <span>
                    แสดง {this.state.data.end_index} จาก {this.state.data.count}{" "}
                    รายการ
                  </span>
                </div>
                <div className="d-flex">
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(1)
                    }}
                  >
                    <span className="icon">{"\uf100"}</span>
                  </button>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.data.count}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                    prevPageText={<span className="icon">{"\uf104"}</span>}
                    nextPageText={<span className="icon">{"\uf105"}</span>}
                    hideFirstLastPages={true}
                  />
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(this.state.data.page_number)
                    }}
                  >
                    <span className="icon">{"\uf101"}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* modal add */}
        <div className={this.state.modal_add ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.clear_form()
            }}
          ></div>
          <div
            className={
              this.state.modal_add ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            <div className="d-flex justify-content-between">
              <h3>
                <b>เพิ่ม QR Code </b>
              </h3>
              <button
                className="btn btn-link d-block d-md-none"
                onClick={() => {
                  this.clear_form()
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            {/* โครงการ */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>โครงการ:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ project_id: e.target.value })
                    this.get_Agency(e.target.value)
                  }}
                  value={this.state.project_id}
                >
                  <option value="">-- เลือกโครงการ --</option>
                  {this.state.project_all_list?.map((project, index) => (
                    <option value={project.project_id}>
                      {project.project_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* หน่วยงาน */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>หน่วยงาน:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ agency_id: e.target.value })
                  }}
                  value={this.state.agency_id}
                >
                  <option value="">-- เลือกหน่วย --</option>
                  {this.state.agency_all_list.map((agency, index) => (
                    <option value={agency.agency_id}>
                      {agency.agency_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* ชื่อจุดสแกนคิวอาร์โค้ด */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>ชื่อจุดสแกนคิวอาร์โค้ด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ name: e.target.value })
                  }}
                  value={this.state.name}
                ></input>
              </div>
            </div>
            {/* ละติจูด */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>ละติจูด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ latitude: e.target.value })
                  }}
                  value={this.state.latitude}
                ></input>
              </div>
            </div>
            {/* ลองติจูด */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>ลองติจูด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ longitude: e.target.value })
                  }}
                  value={this.state.longitude}
                ></input>
              </div>
            </div>
            {/* หมายเหตู */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>หมายเหตุ:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <textarea
                  rows={10}
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ remark: e.target.value })
                  }}
                  value={this.state.remark}
                ></textarea>
              </div>
            </div>
            {/* ปุ่ม */}
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8 ml-auto">
                <div className="row ">
                  <div className="col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3">
                    <button
                      className="btn btn-secondary w-100"
                      onClick={() => {
                        this.clear_form()
                      }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={() => {
                        this.Create()
                      }}
                    >
                      เพิ่มจุด
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* modal edit */}
        <div className={this.state.modal_edit ? "show-modal" : "hide-modal"}>
          <div
            className="w-100 h-100 position-absolute"
            onClick={() => {
              this.clear_form()
            }}
          ></div>
          <div
            className={
              this.state.modal_edit ? "box-modal p-4" : "hide-box-modal p-4"
            }
          >
            <div className="d-flex justify-content-between">
              <h3>
                <b>แก้ไข QR Code </b>
              </h3>
              <button
                className="btn btn-link d-block d-md-none"
                onClick={() => {
                  this.clear_form()
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            {/* โครงการ */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>โครงการ:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ project_id: e.target.value })
                    this.get_Agency(e.target.value)
                  }}
                  value={this.state.project_id}
                  disabled
                >
                  <option value="">-- เลือกโครงการ --</option>
                  {this.state.project_all_list?.map((project, index) => (
                    <option value={project.project_id}>
                      {project.project_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* หน่วยงาน */}
            <div className="row mt-3">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>หน่วยงาน:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <select
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ agency_id: e.target.value })
                  }}
                  value={this.state.agency_id}
                  disabled
                >
                  <option value="">-- เลือกหน่วย --</option>
                  {this.state.agency_all_list.map((agency, index) => (
                    <option value={agency.agency_id}>
                      {agency.agency_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {/* ชื่อจุดสแกนคิวอาร์โค้ด */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>ชื่อจุดสแกนคิวอาร์โค้ด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ name: e.target.value })
                  }}
                  value={this.state.name}
                ></input>
              </div>
            </div>
            {/* ละติจูด */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>ละติจูด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ latitude: e.target.value })
                  }}
                  value={this.state.latitude}
                ></input>
              </div>
            </div>
            {/* ลองติจูด */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>ลองติจูด:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ longitude: e.target.value })
                  }}
                  value={this.state.longitude}
                ></input>
              </div>
            </div>
            {/* หมายเหตู */}
            <div className="row mt-4">
              <div className="col-12 col-sm-12 col-md-4 col-xl-4 col-lg-4">
                <span>หมายเหตุ:</span>
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8">
                <textarea
                  rows={10}
                  className="form-control"
                  onChange={(e) => {
                    this.setState({ remark: e.target.value })
                  }}
                  value={this.state.remark}
                ></textarea>
              </div>
            </div>
            {/* ปุ่ม */}
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-xl-8 col-lg-8 ml-auto">
                <div className="row ">
                  <div className="col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3">
                    <button
                      className="btn btn-secondary w-100"
                      onClick={() => {
                        this.clear_form()
                      }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 mt-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={() => {
                        this.Edit()
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* modal qrcode */}
        <div className={this.state.modal_qrcode ? "show-modal" : "hide-modal"}>
          <div className="w-100 h-100 position-absolute" onClick={() => { this.clear_form() }}/>
          <div className={this.state.modal_qrcode ? "box-modal p-4" : "hide-box-modal p-4"}>
            <div className="d-flex justify-content-between">
              <h3><b>ข้อมูล QR Code</b></h3>
              <button className="btn btn-link d-block d-md-none" onClick={() => {this.clear_form()}}>
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            <div className="p-2 bg-light mb-4">
              <div className="w-100 bg-white text-center"  ref={(el) => (this.qrcode = el)}>
                <div className="bg-primary p-3 mb-3">
                  <h3 className="fw-bold text-light mb-0" style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} title={this.state.project_name}>{this.state.project_name}</h3>
                  <h5 className="fw-bold text-light mb-0" style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} title={this.state.agency_name}>{this.state.agency_name}</h5>
                </div>
                <div className="px-3 pb-4">
                  <h5 className="mb-1">สแกนคิวอาร์โค้ด</h5>
                  <h5 className="mb-0">เพื่อขอความช่วยเหลือ</h5>
                  <hr/>
                  <h5 className="mb-0" style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} title={this.state.name}>{this.state.name}</h5>
                  <div className="d-flex justify-content-center pt-1 mb-2">
                    <div className="position-relative" style={{width:260}}>
                    <QRCode size={200}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={`${window.location.origin}/service?location_id=${encodeURIComponent(this.state.uid)}&project=${encodeURIComponent(this.state.project_name)}&agency=${encodeURIComponent(this.state.agency_name)}`}
                    viewBox={`0 0 200 200`} 
                    />
                    <img
                      src={HALADIEM}
                      alt="logo"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: 48,
                        height: 48,
                        transform: "translate(-50%, -50%)",
                        filter: "drop-shadow(0 0 6px white)",
                      }}
                    />
                    </div>
                  </div>
                  {/* {`${window.location.origin}/service?location_id=${encodeURIComponent(this.state.uid)}&project=${encodeURIComponent(this.state.project_name)}&agency=${encodeURIComponent(this.state.agency_name)}`} */}
                  <h5 className="mb-3">Haladiem Smart Service</h5>
                  <h2 className="fw-bold mb-0">SCAN QR CODE</h2>
                  <h2 className="fw-bold">FOR NEED HELP</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <button className="btn btn-primary w-100" onClick={() => { this.PrintQRCode() }}>Print QR Coode</button>
              </div>
              <div className="col-6">
                <button className="btn btn-warning w-100" onClick={() => { this.DownloadQRCode() }}>Download</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
